import { render, staticRenderFns } from "./SidebarSubheading.vue?vue&type=template&id=2864f884&scoped=true&"
import script from "./SidebarSubheading.vue?vue&type=script&lang=ts&"
export * from "./SidebarSubheading.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarSubheading.vue?vue&type=style&index=0&id=2864f884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864f884",
  null
  
)

export default component.exports